import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';
import transactionApi from '../../../../api/transaction';
import bankApi from '../../../../api/bank';

const defaultState = () => ({
    transactionResults: [],
    transactionPagination: {},
    transactionDetail: {
        data: {
            trx_status_log: [],
            trx_price_grand_total: '',
            stockist: {
                stockist_name: ''
            }
        }
    },
    konfirmResponse: {
        code: '',
        data: {
            from_bank_name: '',
            from_bank_account_name: '',
            from_bank_account_no: '',
            from_bank_branch: '',
            transfer_value: '',
            origin_date: '',
            note: '',
        }
    },
    dataBank: {}
});

const state = defaultState();

const getters = {};

const mutations = {
    reset(state) {
        Object.assign(state, defaultState());
    },
    listTransactionDetailMember(state, data) {
        state.transactionDetail = data;
    },
    resetKonfirmResponse(state) {
        let first = {
            code: '',
            data: {
                from_bank_name: '',
                from_bank_account_name: '',
                from_bank_account_no: '',
                from_bank_branch: '',
                transfer_value: '',
                origin_date: '',
                note: '',
            }
        }
        state.konfirmResponse = Object.assign({}, state.konfirmResponse, first);
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = Object.assign({}, state.konfirmResponse, data);
    },
    listDataBank(state, data) {
        state.dataBank = Object.assign({}, state.dataBank, data);
    },
    listTransaction(state, data) {
        state.transactionResults = data.data;
        state.transactionPagination = data.pagination;
    }
};

const actions = {
    getTransaction({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.Member().then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listTransaction', { data: 'error', pagination: data.pagination });
            } else {
                commit('listTransaction', { data: data.results, pagination: data.pagination });
            }
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getTransactionDetail({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.detailMember(value).then(({ data }) => {
            commit('listTransactionDetailMember', data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            commit('listTransactionDetailMember', 'error');
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    konfirmation({ commit, dispatch, state }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.transferMember(value.param).then((res) => {
            const data = res.data;
            commit('saveConfirmResponse', data)
            if (data.code == 200)
                dispatch('getTransaction');
            if (value.status) {
                dispatch('getTransactionDetail', { code: state.transactionDetail.data.trx_code, mobilephone: state.transactionDetail.data.trx_buyer_mobilephone })
            }
            return true
        }).catch((err) => {
            const data = err.response.data;
            commit('saveConfirmResponse', data)
        });
    },
    search({ commit }, params) {
        let parameterObject = {}
        let parameter = '{'
        params.forEach((value, index) => {
            for (const [key, val] of Object.entries(value)) {
                parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
            }
        })
        parameter = parameter.slice(0, -1)
        parameter += '}'
        parameterObject = JSON.parse(parameter)
        transactionApi.Member(parameterObject).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listTransaction', { data: 'error', pagination: data.pagination });
            } else {
                commit('listTransaction', { data: data.results, pagination: data.pagination });
            }
        })
    },
    filterStatus({ commit }, value) {
        transactionApi.Member({ 'filter[0][value]': value.status, 'filter[0][field]': 'trx_status', 'filter[0][comparison]': '=', 'filter[0][type]': 'string', limit: value.limit }).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listTransaction', { data: 'error', pagination: data.pagination });
            } else {
                commit('listTransaction', { data: data.results, pagination: data.pagination });
            }
        })
    },
    pagination({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        if (value.paramStatus) {
            transactionApi.Member({ 'filter[0][value]': value.paramStatus, 'filter[0][field]': 'trx_status', 'filter[0][comparison]': '=', 'filter[0][type]': 'string', limit: value.paramLimit, page: value.paramPage }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listTransaction', { data: 'error', pagination: data.pagination });
                } else {
                    commit('listTransaction', { data: data.results, pagination: data.pagination });
                }
            })
        } else if (value.paramFilter.length > 0) {
            let parameterObject = {}
            let parameter = '{'
            value.paramFilter.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
                }
            })
            parameter = parameter.slice(0, -1)
            parameter += `,"limit": "${value.paramLimit}", "page": "${value.paramPage}"`
            parameter += '}'
            parameterObject = JSON.parse(parameter)
            transactionApi.Member(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listTransaction', { data: 'error', pagination: data.pagination });
                } else {
                    commit('listTransaction', { data: data.results, pagination: data.pagination });
                }
            })
        } else {
            transactionApi.Member({ page: value.paramPage, limit: value.paramLimit }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listTransaction', { data: 'error', pagination: data.pagination });
                } else {
                    commit('listTransaction', { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            })
        }
    },
    async cancelTransaction({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        await transactionApi.cancelMember(value).then(() => {
            dispatch('getTransaction')
        }).catch((err) => {
            const data = err.response.data;
            commit('saveConfirmResponse', data)
        });
    },
    Penerimaan({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.penerimaanMember(value).then((res) => {
                const data = res.data;
                commit('saveConfirmResponse', data)
                dispatch('getTransactionDetail', { code: state.transactionDetail.data.trx_code, mobilephone: state.transactionDetail.data.trx_buyer_mobilephone })
                dispatch('getTransaction')
            })
            .catch((err) => {
                const data = err.response;
                commit('saveConfirmResponse', data)
            });
    },
    getDataBank({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        bankApi.bankData().then(({ data: { data: { results } } }) => {
            commit('listDataBank', results);
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    errorHandler({ commit }, response) {
        commit('failed', { type: 'error', message: response.message });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};